<template>
    <div>
        <div class="mask" @click="closeNav" v-if="showNavStatus" @touchmove.prevent></div>
        <div class="nav-container" v-if="showNavStatus" :class="showNavStatus ? 'fade-enter-active' : 'fade-leave-active'">
            <div class="header">
                <i class="iconfont icon-quit" @click="closeNav"></i>
            </div>
            <nav>
                <router-link to="/m/">首页</router-link>
                <router-link to="/m/about">关于浙文</router-link>
                <router-link to="/m/service">核心业务</router-link>
                <router-link to="/m/jiandang">党的建设</router-link>
                <router-link to="/m/news">动态与洞察</router-link>
                <router-link to="/m/invest">投资者关系</router-link>
                <router-link to="/m/job">职在浙里</router-link>
                <router-link to="/m/contact">联系我们</router-link>
            </nav>
        </div>
    </div>
</template>
<script>
export default {
    name: "moble-nav",
    data() {
        return {
            showNavStatus: false,
        };
    },
    methods: {
        closeNav() {
            this.showNavStatus = false;
            this.$emit("OnClose");
        },
        showNav() {
            this.showNavStatus = true;
            this.$emit("OnShow");
        },
    },
};
</script>
<style scoped>
@import url("../../../common/css/icon.css");
.mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 9999998;
}
.nav-container nav .router-link-exact-active {
    color: #fff;
}
.nav-container {
    width: 60%;
    background: rgba(0, 122, 255, 0.9);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 100%;
    display: flex;
    flex-direction: column;
    z-index: 9999999;
}
.nav-container nav {
    flex: 1;
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.nav-container nav a {
    font-size: 16px;
    color: #9cc9ff;
    width: 100%;
    padding: 15px 0;
}
.nav-container .header {
    display: flex;
    justify-content: flex-end;
}
.nav-container .header i {
    padding: 10px;
    margin: 5px;
    color: #fff;
    font-size: 2.4rem;
}

.fade-enter-active {
    animation: fade-in 0.3s ease forwards;
}
.fade-leave-active {
    animation: fade-in 0.3s ease reverse;
}
@keyframes fade-in {
    0% {
        /* transform: translateX(0); */
        visibility: visible;
        left: 100%;
    }
    100% {
        /* transform: translateX(80%); */
        left: 40%;
    }
}
</style>
